export default [
  {
    title: "Dashboard",
    icon: "HomeIcon",
    route: "dashboard-analytics",
    // tag: "1",
    tagVariant: "light-warning",
  },
];
